import { InputNumber } from "antd";
import React from "react";
import * as S from "./style";

interface Props {
  disabled?: boolean;
  onChange?: (e: number) => void;
  handleUp?: () => void;
  handleDown?: () => void;
  max?: number;
  value?: number;
}

function InputNumberNew({
  disabled,
  onChange,
  max = 0,
  handleUp,
  handleDown,
  value = 1,
}: Props) {
  return (
    <S.Container>
      <div
        className="btn-count minus"
        onClick={() => {
          if (value > 1 && !disabled) {
            handleDown?.();
          }
        }}
      >
        -
      </div>
      <InputNumber
        min={1}
        max={max}
        value={value}
        onChange={(e) => onChange?.(e || 0)}
        formatter={(
          value: number | undefined,
          _info?: { userTyping: boolean; input: string }
        ) => (value !== undefined ? value.toString().padStart(2, "0") : "00")}
        disabled={disabled}
        controls={false}
      />
      <div
        className="btn-count plus"
        onClick={() => {
          if (!disabled && value < max) {
            handleUp?.();
          }
        }}
      >
        +
      </div>
    </S.Container>
  );
}

export default InputNumberNew;
